module.exports = __webpack_public_path__ + "img/newyear.368bcccf.png";